export default __webpack_public_path__ + "static/media/icmp_connection.40ac69dd.svg";